import { useMemo } from 'react';
import { CellProps, Column } from 'react-table';
import { QuestionDTO } from '../../../api/api';
import useTableInstance from '../../../hooks/useTableInstance';
import { getEnumDisplayValue } from '../../../utils/enumUtils';
import {
  Cell,
  SearchColumnFilter,
  SelectBooleanColumnFilter,
  SelectColumnFilter,
  multiSelectFilterFn
} from '../../../blocks/table/TableFilterUtils';

export interface ChecklistQuestionData {
  id?: number;
  text?: string;
  questionType?: string;
  hasLink?: string;
}

const useChecklistQuestionList = (questions: QuestionDTO[]) => {
  const data = useMemo(() => {
    return questions.map((q) => {
      return {
        ...q,
        questionType: q.questionType ? getEnumDisplayValue(q.questionType) : '',
        hasLink: !q.link ? 'Nej' : 'Ja'
      } as ChecklistQuestionData;
    });
  }, [questions]);

  const columns = useMemo(() => {
    return [
      {
        Header: 'Id',
        accessor: 'id',
        width: 50,
        minWidth: 50,
        Filter: SearchColumnFilter,
        filter: 'text'
      },
      {
        Header: 'Tekst',
        accessor: 'text',
        width: 200,
        Filter: SearchColumnFilter,
        filter: 'text'
      },
      {
        Header: 'Type',
        accessor: 'questionType',
        width: 100,
        minWidth: 100,
        Filter: SelectColumnFilter,
        filter: multiSelectFilterFn
      },
      {
        Header: 'Har link',
        accessor: 'hasLink',
        width: 100,
        minWidth: 100,
        Filter: SelectBooleanColumnFilter,
        filter: multiSelectFilterFn,
        Cell: (cellProps: CellProps<ChecklistQuestionData>) => {
          const { cell } = cellProps;
          return <Cell>{cell.value}</Cell>;
        }
      }
    ] as Column<ChecklistQuestionData>[];
  }, []);

  const tableInstance = useTableInstance<ChecklistQuestionData>(data, columns);

  return { tableInstance };
};

export default useChecklistQuestionList;
